import { api } from './client';

export type ServiceActiveState =
  | 'active' | 'inactive' | 'failed' | 'activating' | 'deactivating' | 'unknown';

export type ServiceAction = 'start' | 'stop' | 'restart' | 'enable' | 'disable';

export interface ServiceItem {
  id: string;
  name: string;
  unit: string;
  description: string;
  active: ServiceActiveState;
  enabled: boolean;
  activeSince?: string;
}

export interface ServicesResponse {
  services: ServiceItem[];
}

export const fetchServices = (): Promise<ServicesResponse> =>
  api.get<ServicesResponse>('/services').then((r) => r.data);

export const controlService = (id: string, action: ServiceAction): Promise<void> =>
  api.post(`/services/${id}/${action}`).then(() => undefined);

export const fetchServiceLogs = (id: string, lines = 200): Promise<{ lines: string[] }> =>
  api.get<{ lines: string[] }>(`/services/${id}/logs`, { params: { lines } }).then((r) => r.data);
